export default class UserList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.id] = entry
		}
	}

	static async fetch () {

		let data = await Anvil.REST.get('/user')

		return new UserList(data)
	}

	getById (id) {
		return this.index[id]
	}
}
